import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { handleApiError } from '../../utils/errorHandler';
import AddParentModal from './AddParentModal';

const ParentsTab = () => {
  const [parents, setParents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddParentModal, setShowAddParentModal] = useState(false);
  const [deletingParentId, setDeletingParentId] = useState(null);

  useEffect(() => {
    loadParents();
  }, []);

  const loadParents = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/parents');
      setParents(response.data);
    } catch (err) {
      console.error('Error loading parents:', err);
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const handleDeleteParent = async (parent) => {
    const confirmed = window.confirm(
      `Delete parent "${parent.username}"?\n\nThis will:\n- anonymize parent and children personal data\n- delete only regular GPT chats\n- delete quiz attempts\n\nSchool learning and quiz content will be kept.`
    );
    if (!confirmed) return;

    try {
      setDeletingParentId(parent.id);
      await api.delete(`/admin/parents/${parent.id}`);
      await loadParents();
    } catch (err) {
      console.error('Error deleting parent:', err);
      handleApiError(err);
    } finally {
      setDeletingParentId(null);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h2>All Parents & Children</h2>
        <button
          className="btn-secondary"
          onClick={() => setShowAddParentModal(true)}
          style={{
            padding: '0.5rem 1rem',
            fontSize: '0.85rem',
            whiteSpace: 'nowrap'
          }}
        >
          + Add Parent
        </button>
      </div>
      {loading ? (
        <div className="loading">Loading parents...</div>
      ) : parents.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {parents.map((parent) => (
            <div key={parent.id} style={{
              background: 'white',
              padding: '1.5rem',
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 600 }}>{parent.username}</h3>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.65rem' }}>
                  <span style={{ fontSize: '0.9rem', color: '#718096' }}>
                    {parent.children_count} {parent.children_count === 1 ? 'child' : 'children'}
                  </span>
                  <button
                    type="button"
                    className="btn-secondary"
                    onClick={() => handleDeleteParent(parent)}
                    disabled={deletingParentId === parent.id}
                    style={{
                      padding: '0.35rem 0.75rem',
                      fontSize: '0.8rem',
                      borderColor: '#fca5a5',
                      color: '#b91c1c',
                      background: '#fef2f2'
                    }}
                  >
                    {deletingParentId === parent.id ? 'Deleting...' : 'Delete Parent'}
                  </button>
                </div>
              </div>
              {parent.email && (
                <p style={{ margin: '0.5rem 0', color: '#718096' }}>Email: {parent.email}</p>
              )}
              <p style={{ margin: '0.5rem 0', fontSize: '0.9rem', color: '#718096' }}>
                Created: {formatDate(parent.created_at)}
              </p>
              {parent.children && parent.children.length > 0 && (
                <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #e2e8f0' }}>
                  <h4 style={{ marginBottom: '0.75rem', fontSize: '1rem', fontWeight: 600 }}>Children:</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '0.75rem' }}>
                    {parent.children.map((child) => (
                      <div key={child.id} style={{
                        padding: '0.75rem',
                        background: '#f7fafc',
                        borderRadius: '8px',
                        border: '1px solid #e2e8f0'
                      }}>
                        <div style={{ fontWeight: 600, marginBottom: '0.25rem' }}>{child.username}</div>
                        <div style={{ fontSize: '0.85rem', color: '#718096' }}>
                          Age: {child.age || 'N/A'} | Language: {child.language || 'en'}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <p>No parents found.</p>
        </div>
      )}

      {/* Add Parent Modal */}
      {showAddParentModal && (
        <AddParentModal
          onClose={() => setShowAddParentModal(false)}
          onParentAdded={loadParents}
        />
      )}
    </div>
  );
};

export default ParentsTab;

